import React from "react";

export default function PageNotFound() {
  return (
    <div className="flex flex-col items-center justify-center w-full">
      <img className="not-found" src="../images/404.png" alt="not-found" />

      <div className="not-found-text">There's no place like home. </div>
      <div className="mt-2 text-xl">This page does not exist.</div>
      <div className="flex text-center  mt-2 text-lg">
        <p>
          Click your heels...or your mouse gently, and{" "}
          <a href="/">return home.</a>
        </p>
      </div>
    </div>
  );
}
